// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniCartLineStyles } from "@west/App/Components/MiniCart/MiniCartLineCard";
import cartLineSharedStyles from "@west/App/SharedStyles/CartLineSharedStyles";
import Remove from "@west/XDL/Icons/Remove";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

miniCartLineStyles.container = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 20px;
        padding-top: 12px;
        border-top: 1px solid ${color("common.border")};
        margin-top: 12px;
    `,
};

miniCartLineStyles.descriptionContainer = {
    css: css`
        display: flex;
        gap: 12px;
        flex-basis: 331px;
        min-width: 331px;
    `,
};

miniCartLineStyles.descriptionColumnContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,
};

miniCartLineStyles.qtyContainer = {
    css: css`
        flex-grow: 1;
        display: flex;
        align-items: center;
    `,
};

miniCartLineStyles.priceContainer = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
    `,
};

miniCartLineStyles.productImage = {
    linkWrappingImage: {
        css: css`
            width: 68px;
            height: 68px;
            flex-shrink: 0;
            margin-left: 1px;
        `,
    },
    img: {
        css: css`
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        `,
    },
};

miniCartLineStyles.extendedUnitNetPriceText = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        letter-spacing: 0;
        line-height: 17px;
        margin-bottom: 0;
    `,
};

miniCartLineStyles.removeIcon = {
    src: Remove,
    size: 11,
    color: "common.ui6",
    css: css`
        margin-left: 12px;
        cursor: pointer;
        &:hover {
            color: ${color("common.ui9")};
            opacity: 0.66;
        }
    `,
};

miniCartLineStyles.cartLineErrorMessageWrapper = {
    ...cartLineSharedStyles.cartLineErrorMessageGridItem,
};

miniCartLineStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};
